<template>
  <ul>
    <component
      :is="resolveNavItemComponent(item)"
      v-for="item in filterdItems"
      :key="item.header || item.title"
      :item="item"
    />
  </ul>
</template>

<script>
import { resolveVerticalNavMenuItemComponent as resolveNavItemComponent } from '@core/layouts/utils'
import { provide, ref } from '@vue/composition-api'
import VerticalNavMenuHeader from '../vertical-nav-menu-header'
import VerticalNavMenuLink from '../vertical-nav-menu-link/VerticalNavMenuLink.vue'
import VerticalNavMenuGroup from '../vertical-nav-menu-group/VerticalNavMenuGroup.vue'

export default {
  components: {
    VerticalNavMenuHeader,
    VerticalNavMenuLink,
    VerticalNavMenuGroup,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      filterdItems: this.items
    }
  },
  watch:{
    '$route.name'(newVal){
      this.filterItems()
    }
  },
  methods:{
    filterItems() {
      if(this.$route.name == 'v1_admin_dashboard' || this.$route.name == 'v1_userss' || this.$route.name == 'v2_admin_dashboard' || this.$route.name == 'v2_userss'){

          const filtered = []
          let skip = false
    
          for (const item of this.items) {
            // If it's the header "All", activate skip mode
            if (item.header === 'All') {
              skip = true
              continue
            }
    
            // If it's another header, stop skipping
            if (item.header && item.header !== 'All') {
              skip = false
              filtered.push(item)
              continue
            }
    
            // If we're in skip mode, skip all items
            if (skip) continue
    
            // Otherwise, include the item
            filtered.push(item)
          }
    
          this.filterdItems = filtered
      }else{
        this.filterdItems = this.items.filter(item => {
          return item.title !== 'Dashboard' && item.title !== 'Users'
        })
      }
    }
  },
  mounted(){
    this.filterItems()
  },
  setup() {
    provide('openGroups', ref([]))

    return {
      resolveNavItemComponent,
    }
  },
}
</script>
